export class Pays {

    pay_id: string;
    pay_ref: string;
    pay_libelle: string;
    pay_libelle_en: string;
    pay_libelle_nl: string;
    pay_readonly: boolean;
    pay_defaut: number;

    constructor(data?: any) {
        if (!data) {
            data = [];
        }

        this.pay_id             = data['pay_id'] ? data['pay_id'] : null;
        this.pay_ref            = data['pay_ref'] ? data['pay_ref'] : null;
        this.pay_libelle        = data['pay_libelle'] ? data['pay_libelle'] : null;
        this.pay_libelle_en     = data['pay_libelle_en'] ? data['pay_libelle_en'] : null;
        this.pay_libelle_nl     = data['pay_libelle_nl'] ? data['pay_libelle_nl'] : null; 
        this.pay_readonly       = data['pay_readonly'] ? (data['pay_readonly'] === '1' ? true : false) : false;
        this.pay_defaut         = data['pay_defaut'] ? data['pay_defaut'] : null;
    }

}
